export const svgNS = 'http://www.w3.org/2000/svg'
export const svgTextAnchor: { [key: string]: string } = {
  top: 'middle',
  bottom: 'middle',
  left: 'left',
  right: 'right',
}
